import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Overview = styled.div`
  display: flow-root;
  min-width: 0;
  text-wrap: pretty;

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: ${rem(16)};
    align-items: start;

    &.has-gallery { grid-template-columns: minmax(0, 40%) minmax(0, 1fr); }
  }

  ${mediaQueryUp.desktop} {
    display: block;
  }
`

const Thumbnail = styled.div`
  float: inline-end;
  margin-inline-start: ${rem(12)};
  margin-block-end: ${rem(8)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const Gallery = styled.div`
  display: none;
  min-width: 0;

  ${mediaQueryUp.tablet} {
    display: block;
  }

  ${mediaQueryUp.desktop} {
    margin-block-end: ${rem(12)};
  }
`

const Content = styled.div`
  display: contents;
  ${mediaQueryUp.tablet} {
    display: block;
    min-width: 0;
  }
`

const Title = styled.div`
  margin-block-end: ${rem(8)};
`

interface Props extends PropsWithChildren {
  title: ReactNode
  thumbnail?: ReactNode
  gallery?: ReactNode
}

/** Inline detail regions naturally regain the full width after the thumbnail ends. */
function AccommodationPackageRoomOverview({ title, thumbnail, gallery, children }: Props) {
  return <Overview className={clsx({ 'has-gallery': !!gallery })}>
    {thumbnail && <Thumbnail>{thumbnail}</Thumbnail>}
    {gallery && <Gallery>{gallery}</Gallery>}
    <Content>
      <Title>{title}</Title>
      {children}
    </Content>
  </Overview>
}

export default AccommodationPackageRoomOverview
